import { storeAnnio } from './stores'
import { urlServer } from '../mapboxgl/index.js'
//const urlServer='http://ec2-34-221-108-190.us-west-2.compute.amazonaws.com'
//const urlServer='http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com'
//const urlServer='http://localhost:3000'
export const getAnnio = async () =>{
    try{
        let url = "${urlServer}/api"
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getTotPais = async (param) =>{
    try{
        let url = `${urlServer}/api/totPais?annio=${param['annio']}&sensor=${param['sensor']}&pcFiltro=${param['pcFiltro']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getTotEstado = async (param) =>{
    try{
        let url = `${urlServer}/api/totEstado?annio=${param['annio']}&pais=${param['pais']}&sensor=${param['sensor']}&pcFiltro=${param['pcFiltro']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getTotMunicipio = async (param) =>{
    try{
        let url = `${urlServer}/api/totMunicipio?annio=${param['annio']}&pais=${param['pais']}&estado=${param['estado']}&sensor=${param['sensor']}&pcFiltro=${param['pcFiltro']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getTotPaisAnp = async (param) =>{
    try{
        let url = `${urlServer}/api/totPaisAnp?annio=${param['annio']}&sensor=${param['sensor']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getTotEstadoAnp = async (param) =>{
    try{
        let url = `${urlServer}/api/totEstadoAnp?annio=${param['annio']}&pais=${param['pais']}&sensor=${param['sensor']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getTotMunicipioAnp = async (param) =>{
    try{
        let url = `${urlServer}/api/totMunicipioAnp?annio=${param['annio']}&pais=${param['pais']}&estado=${param['estado']}&sensor=${param['sensor']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getTotPaisForestal = async (param) =>{
    try{
        let url = `${urlServer}/api/totPaisForestal?annio=${param['annio']}&sensor=${param['sensor']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getTotEstadoForestal = async (param) =>{
    try{
        let url = `${urlServer}/api/totEstadoForestal?annio=${param['annio']}&pais=${param['pais']}&sensor=${param['sensor']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getTotMunicipioForestal = async (param) =>{
    try{
        let url = `${urlServer}/api/totMunicipioForestal?annio=${param['annio']}&pais=${param['pais']}&estado=${param['estado']}&sensor=${param['sensor']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}

